import React from 'react'
import { Navigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import { useTenantContext } from '@/context'
import { getDefaultDonatePath } from '@/utils/primary-donation-nav'

export const DonateNavNotConfiguredPage = () => {
  const { tenant, loadingTenant } = useTenantContext()

  if (loadingTenant) {
    return null
  }

  const target = getDefaultDonatePath(tenant)
  if (target != null) {
    return <Navigate to={target} replace />
  }

  return (
    <Box
      sx={{
        py: { xs: 4, md: 6 },
        px: { xs: 2, md: 3 },
        maxWidth: 560,
        mx: 'auto',
      }}
    >
      <Typography variant='h5' component='h1' fontWeight={700} gutterBottom>
        Scheduling isn&apos;t available here yet
      </Typography>
      <Typography variant='body1' color='text.secondary' sx={{ mb: 2 }}>
        Online donation scheduling has not been enabled for this organization.
        Please contact your blood center or sponsor if you need help booking an
        appointment.
      </Typography>
    </Box>
  )
}
